import React from 'react';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [showConsent, setShowConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowConsent(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowConsent(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowConsent(false);
  };

  const handleCustomize = () => {
    localStorage.setItem('cookieConsent', 'customize');
    setShowConsent(false);
  };

  if (!showConsent) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-content">
        <div className="cookie-text">
          <h3>Χρησιμοποιούμε Cookies</h3>
          <p>
            Η ιστοσελίδα μας χρησιμοποιεί cookies για να βελτιώσει την εμπειρία σας, 
            να αναλύσει την επισκεψιμότητα και να εξατομικεύσει το περιεχόμενο. 
            Τα cookies μας βοηθούν να κατανοήσουμε πώς χρησιμοποιείτε τον ιστότοπό μας 
            και να βελτιώσουμε τις υπηρεσίες μας.
          </p>
          <p>
            Για περισσότερες πληροφορίες, διαβάστε την{' '}
            <Link to="/privacy-policy">Πολιτική Απορρήτου</Link> μας.
          </p>
        </div>
        <div className="cookie-buttons">
          <button className="cookie-btn accept" onClick={handleAccept}>
            Αποδοχή Όλων
          </button>
          <button className="cookie-btn decline" onClick={handleDecline}>
            Απόρριψη
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;